import { atom } from 'jotai';

export const autoAdvancingAtom = atom(false);
